import { Theme } from "@amx/ux-twoui-theming";
import { ILinkStyles, IStackStyles } from "@fluentui/react";
import { IconBackplateSize } from "../../styles/icons";
import { BorderRadius } from "../Image/Image.types";
import { TextHost } from "./Media.types";

export const getStackForIconBackplateStyle = (backplateSize?: string, computedBackplateColor?: string, backplateBorderRadius?: string): IStackStyles => ({
    root: {
        width: backplateSize,
        backgroundColor: computedBackplateColor,
        fontSize: backplateSize,
        lineHeight: backplateSize,
        minHeight: backplateSize,
        borderRadius: backplateBorderRadius || "0px"
    }
});

export const getStackForImageBackplateStyle = (backplateSize: string, backplateColor: string, borderRadius?: BorderRadius): IStackStyles => ({
    root: {
        width: backplateSize,
        height: backplateSize,
        backgroundColor: backplateColor,
        borderRadius: borderRadius || "0px"
    }
});

export const getStackForIconStyle = (backplateSize?: IconBackplateSize): IStackStyles => ({
    root: {
        width: backplateSize,
        height: backplateSize,
        position: "absolute",
        verticalAlign: "center",
        textAlign: "center",
    }
});

export const getStylesForTextHost = (textHost: TextHost, theme: Theme, borderRadius?: BorderRadius): React.CSSProperties => ({
    position: "absolute",
    backgroundColor: theme.palette[textHost.backgroundColor],
    width: "100%",
    bottom: "0px",
    height: textHost.type === "topAligned" ? "33%" : undefined,
    borderBottomLeftRadius: borderRadius,
    borderBottomRightRadius: borderRadius,
    paddingBottom: "6px",
    paddingTop: "6px",
    paddingLeft: "8px",
    paddingRight: "8px",
    opacity: "75%",
    boxSizing: "border-box"
});

export const getMediaLinkStyles = (): ILinkStyles => ({
    root: {
        selectors: {
            // Overwrite default link style
            ":hover": {
                textDecoration: "none"
            },
            ":active:focus": {
                textDecoration: "none"
            },
        }
    }
});
